import { Issue } from './issue';

export class Message {
  public id?: number;
  public content: string;
  public timestamp: Date;
  public channelId: number;
  public senderId: string;
  public isKIIgnored = false;
  public isRead?: boolean;
  public issueId?: string;
  public issue: Issue;


  constructor(
    content: string,
    timestamp: Date,
    channelId: number,
    senderId: string,
    isKIIgnored: boolean,
    isRead?: boolean,
    issueId?: string,
    id?: number
  ) {
    this.id = id;
    this.content = content;
    this.timestamp = timestamp;
    this.channelId = channelId;
    this.senderId = senderId;
    this.isKIIgnored = isKIIgnored;
    this.isRead = isRead;
    this.issueId = (typeof issueId !== 'undefined' && issueId !== null) ? issueId : null;
  }

  public mapForChatAnalysis(): any {
    return {
      id: this.id,
      content: this.content,
      timestamp: this.timestamp.toISOString(),
      channel_id: this.channelId,
      sender_id: this.senderId,
      is_ki_ignored: this.isKIIgnored,
      is_read: this.isRead
    };
  }

  public static fromJSON(data: any): Message {
    return new Message(
      data.content,
      new Date(data.timestamp),  // Ensure timestamp is Date
      data.channel_id || data.channelId,
      data.sender_id || data.senderId,
      data.is_ki_ignored || data.isKIIgnored,
      data.is_read || data.isRead,
      data.issue_id || data.issueId,
      data.id
    );
  }

  public static mapMessagesForChatAnalysis(messages: any[]): any[] {
    return messages.map(msg => Message.fromJSON(msg).mapForChatAnalysis());
  }
}
